import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { BOOKING_STEPS_BY_TUNNEL, BookingTunnel } from "../constants/bookingSteps";
import { getBookingStepUrls } from "../store/bookingStepUrlsSelector";

type UseBookingStepsParams = {
	tunnel?: BookingTunnel;
};

/** Builds the tunnel's steps for the stepper: each step's label, its persisted url (undefined until visited), the active step index and whether completed steps are clickable. The tunnel decides which steps are shown (prepackage keeps the search step, the others start at the quote); an undefined tunnel yields no steps. */
export const useBookingSteps = ({ tunnel }: UseBookingStepsParams = {}) => {
	const { formatMessage } = useIntl();
	const { pathname } = useLocation();
	const urlsByStep = useSelector(getBookingStepUrls);

	const activeSteps = tunnel ? BOOKING_STEPS_BY_TUNNEL[tunnel] : [];

	const steps = activeSteps.map(step => ({
		key: step.key,
		label: formatMessage({ id: step.labelId }),
		to: urlsByStep[step.key],
	}));

	const value = activeSteps.findIndex(step => pathname.includes(step.pathname));
	const clickable = value >= 0 && value < activeSteps.length - 1;

	return { steps, value, clickable };
};
